import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { stringFormat } from '@brycemarshall/string-format';
import { DeleteConfirmationComponent } from 'src/app/shared/components/delete-confirmation/delete-confirmation.component';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { UtilityService } from 'src/app/shared/services/utility.service';

import { CommonConstants } from '../../constants/common.constant';

@Component({
  selector: 'app-custom-file-upload',
  templateUrl: './custom-file-upload.component.html',
  styleUrls: ['./custom-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CustomFileUploadComponent implements OnInit {
  private dialog = inject(MatDialog);
  private utilityService = inject(UtilityService);
  private emitterService = inject(EmitterService);

  @Input() public isMultiple: boolean;
  @Input() public validFileTypes: string[];
  @Input() public maxFilesLimit: number;
  @ViewChild('file') public file: ElementRef;
  @Input() public fileSizeLimit: number;
  @Input() public isDeleteConfirmation: boolean;
  @Output() public fileChanged = new EventEmitter();
  @Input() public browseText: string;
  public uploadFiles: File[] = [];

  public ngOnInit(): void {
    this.initializeModel();
  }

  public getMultipleStatus(): boolean {
    return this.isMultiple;
  }

  /**
   * This method is called when user selects file, add file and display growler in case File doesnt meet criteria.
   * @param {Model.FileList} fileList
   */
  public selectFile(fileList: FileList): void {
    let isInvalidTypeSizeCriteria;
    const files = Array.from(fileList);
    this.emitterService.notifyCloseGrowl(true);
    if (this.uploadFiles.length + fileList.length > this.maxFilesLimit) {
      this.utilityService.showGrowelMessage(stringFormat(CommonConstants.errorCodes.fileCountErrorMessage, { maxFileLimit: this.maxFilesLimit }), false);
      return;
    }
    files.forEach((file: File) => {
      if (this.validFileTypes.includes(file.type) && file.size < this.fileSizeLimit) {
        this.uploadFiles.push(file);
      } else {
        isInvalidTypeSizeCriteria = true;
      }
    });
    this.fileChanged.emit(this.uploadFiles);
    if (isInvalidTypeSizeCriteria) {
      this.utilityService.showGrowelMessage(CommonConstants.errorCodes.fileTypeSizeErrorMessage, false);
      return;
    }
  }
  /**
   * This method is called when user tries to delete a browsed file .
   * @param {Model.File} fileInfo
   */
  public deleteFile(fileInfo: File): void {
    const dialogRef: MatDialogRef<DeleteConfirmationComponent, string[]> = this.dialog.open(DeleteConfirmationComponent, {
      disableClose: true,
      position: {
        top: '7%',
      },
      width: '430px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const index: number = this.uploadFiles.indexOf(fileInfo);
        this.uploadFiles.splice(index, 1);
        this.fileChanged.emit(this.uploadFiles);
      }
    });
  }

  private initializeModel(): void {
    this.uploadFiles = new Array<File>();
  }
}
